import { useEffect, useState } from 'react';

// Unread Intercom conversations of the current user, 0 until the messenger has booted
const useIntercomUnreadCount = (isEnabled) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isEnabled) return undefined;
    let isMounted = true;
    // Intercom has no way to unsubscribe, the listener goes quiet after unmount instead
    if (window.Intercom) {
      window.Intercom('onUnreadCountChange', (unreadCount) => {
        if (isMounted) setCount(unreadCount);
      });
    }
    return () => {
      isMounted = false;
    };
  }, [isEnabled]);

  return count;
};

export default useIntercomUnreadCount;
